import { mapProductItem } from '@shared/analytics/mapper'
import type { GooglePlugin } from '@shared/analytics/types/google'
import {
  onSelectItemEvent,
  onViewItemEvent,
  onViewItemListEvent,
  removeSelectItemEvent,
  removeViewItemEvent,
  removeViewItemListEvent,
} from '@shared/event/events/product'

export const initProductEvents = (Analytics: GooglePlugin) => {
  const viewItemEvent = onViewItemEvent((product) => {
    Analytics.event({
      ecommerce_ga4: null,
    })
    Analytics.event({
      event: 'view_item',
      ecommerce_ga4: {
        items: [{ ...mapProductItem(product) }],
      },
    })
  })

  const selectItemEvent = onSelectItemEvent((eventData): void => {
    if (!eventData.listName) return
    Analytics.event({
      ecommerce_ga4: null,
    })
    Analytics.event({
      event: 'select_item',
      ecommerce_ga4: {
        item_list_id: eventData.listId?.toString(),
        item_list_name: eventData.listName,
        items: [{ ...mapProductItem(eventData.product) }],
      },
    })
  })

  const itemListMap = new Map()
  const viewItemListEvent = onViewItemListEvent((list) => {
    if (itemListMap.has(list.cacheId)) {
      return
    }

    itemListMap.set(list.cacheId, list)

    Analytics.event({
      ecommerce_ga4: null,
    })

    Analytics.event({
      event: 'view_item_list',
      ecommerce_ga4: {
        item_list_name: list.name,
        items: list.items.map(mapProductItem),
      },
    })
  })

  return () => {
    removeSelectItemEvent(selectItemEvent)
    removeViewItemListEvent(viewItemListEvent)
    removeViewItemEvent(viewItemEvent)
    itemListMap.clear()
  }
}
